import actions from '../../actionTypes';

export default (siteId) => {
  return {
    type: actions.STREAM_TAGS,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/streamTags.js